import React, { createContext, useContext, useState } from 'react';

const LogoFontContext = createContext(null);

export function LogoFontProvider({ children }) {
  const [font, setFont] = useState('Cinzel');
  return (
    <LogoFontContext.Provider value={{ font, setFont }}>
      {children}
    </LogoFontContext.Provider>
  );
}

export function useLogoFont() {
  return useContext(LogoFontContext);
}
